/**
 * The shield with a chevron - controlled passage, in exactly two shapes. Same
 * geometry as the favicon, so the tab and the sidebar show one mark rather
 * than two drawings of the same idea.
 *
 * It takes its colour from the theme tokens instead of the fixed blue the
 * favicon needs: on a dark surface the flat brand blue goes muddy, and the
 * accent token is already tuned for both.
 */
export function BrandMark({ size = 22 }: { size?: number }) {
  return (
    <svg
      className="brand-mark"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M16 1.6 29 6.3v8.9c0 7.6-5.5 12.7-13 15.2-7.5-2.5-13-7.6-13-15.2V6.3z"
        fill="var(--accent)"
      />
      <path
        d="M12.2 10.2 19.4 16l-7.2 5.8"
        fill="none"
        stroke="var(--on-accent)"
        strokeWidth="4.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
